import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { UseUserProfileStoreProps } from './useUserProfileStore.types'

const useUserProfileStore = create<UseUserProfileStoreProps>()(
  devtools(
    (set) => ({
      visible: false,
      userUcode: undefined,
      setVisible: (value) => set({ visible: value }),
      setUserUcode: (ucode) => set({ userUcode: ucode }),
      reset: () => set({ visible: false, userUcode: undefined })
    }),
    { anonymousActionType: 'userProfileStore' }
  )
)

export default useUserProfileStore
